var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{staticClass:"primary my-btn tw-px-3 tw-py-2",attrs:{"rounded":""},on:{"click":_vm.addEquipment}},[_vm._v(_vm._s(_vm.$t("button.addEquipment")))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }